import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL, SITE_NAME } from "@/data/seo";

// Brand-safe SVG OG image (no third-party imagery)
const DEFAULT_OG = `${SITE_URL}/og-cover.svg`;

// Central per-page SEO tags. Pass canonical PATH (starting with /) not full URL.
export const Seo = ({ title, description, canonical = "/", image, jsonld, noindex = false }) => {
  const canonicalUrl = canonical.startsWith("http") ? canonical : `${SITE_URL}${canonical}`;
  const ogImage = image || DEFAULT_OG;

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_GB" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {jsonld && (
        <script type="application/ld+json">
          {JSON.stringify(jsonld)}
        </script>
      )}
    </Helmet>
  );
};
